import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { SplitText } from 'gsap/SplitText';
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

import scrollLock from 'scroll-lock';

import Videos from './components/Videos';
import Cursor from './components/Cursor';

import Spa from './barba/Spa';
import Header from './classes/Header';
import Footer from './classes/Footer';

export class Today {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Today.domReady()]).then(() => this.init());
	}

	init() {
		window.addEventListener('resize', () => {
			this.setVh();
		});
		this.setVh();

		new Spa();
		new Header();

		new Cursor();
		new Videos();

		//region cookienag
		(function(){
			const localStorage = window.localStorage;
			if(localStorage){
				function getCookie() {
					const cookiePairs = document.cookie.split(';');
					for (let cookiePair of cookiePairs) {
						cookiePair.trim();
						const [name, value] = cookiePair.split('=', 2);
						if (decodeURIComponent(name.trim()) === 'september-cookie') {
							return JSON.parse(decodeURIComponent(value));
						}
					}
					return null;
				}

				try {
					const consentCookie = getCookie() || [];

					if(consentCookie.length <= 0){
						return;
					}

					if(consentCookie.find(x=>x.id==='marketing')?.accepted === true){
						return;
					}


					let previousNags = localStorage.getItem('cookie-nag') || 0;
					let previousNagThreshold = localStorage.getItem('cookie-nag-threshold') || 0;

					if(previousNags < 3 && (+new Date() > previousNagThreshold)){
						previousNags++;
						localStorage.setItem('cookie-nag', previousNags);

						//show the cookie bar
						setTimeout(function(){
							const elm = document.querySelector('[data-role="september-cookie-consent"]');
							elm.style.display = '';
							elm.removeAttribute('aria-hidden');
							elm.removeAttribute('hidden');
						}, 1000);

						document.addEventListener("visibilitychange", function(){
							localStorage.setItem('cookie-nag-threshold', (+new Date()) + 10*1000);
						});
					}

				}catch(e){
					console.error(e);
				}
			}
		})();
		//endregion cookienag

		document.addEventListener('bless', (e) => {
			let mm = gsap.matchMedia();
			mm.add(
				{
					hasHover: '(hover: hover) and (pointer: fine)',
				},
				(context) => {
					let { hasHover } = context.conditions;

					if (hasHover) {
						// create the scrollSmoother before your scrollTriggers
						this.smoother = ScrollSmoother.create({
							wrapper: e.detail.element.querySelector('#smooth-wrapper'),
							content: e.detail.element.querySelector('#smooth-content'),
							normalizeScroll: false,
							ignoreMobileResize: true,
							smooth: 2, // how long (in seconds) it takes to "catch up" to the native scroll position
							effects: true, // looks for data-speed and data-lag attributes on elements
						});
						window.dispatchEvent(new CustomEvent('disable-scroll'));
					}
				}
			);

			new Footer(e);
		});

		window.addEventListener('disable-scroll', () => {
			if (this.smoother) {
				this.smoother.paused(true);
			} else {
				scrollLock.disablePageScroll();
			}
		});

		window.addEventListener('enable-scroll', () => {
			if (this.smoother) {
				this.smoother.paused(false);
			} else {
				scrollLock.clearQueueScrollLocks();
				scrollLock.enablePageScroll();
			}
		});

		window.addEventListener('disable-smooth-scroll', () => {
			if (this.smoother) {
				this.smoother.paused(true);
			}
		});

		window.addEventListener('enable-smooth-scroll', () => {
			if (this.smoother) {
				this.smoother.paused(false);
			}
		});

		jQuery(document).on('submit', 'form[data-formid]', function (evt) {
			const el = evt.target;
			if (!el.querySelector('[name="version_hash"]')) {
				const hiddenInput = `<input
					type="hidden"
					name="version_hash"
					value="${window.gform_theme_config?.common?.form?.honeypot?.version_hash}"
				/>`;
				el.insertAdjacentHTML('beforeend', hiddenInput);
			}
		});
	}

	setVh() {
		const vh = window.innerHeight / 100;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Today();
